module.exports = __webpack_public_path__ + "static/media/bell.534a3364.svg";